import * as discoverRoutines from './discoverRoutines';
import { connect } from 'react-redux';
import { makeActiveDiscover, makeSitePagesOptions } from './discoverSelectors';
import DiscoverDetailsForm from '../../Components/Discover/Form/DiscoverDetailsForm';

function mapStateToProps(state) {
    return {
        activeDiscover: makeActiveDiscover(state),
        activeDiscoverId: state.ui.active_discover_id,
        discoverCardStatus: state.ui.discoverCardStatus,
        sitePages: makeSitePagesOptions(state),
    };
}

const mapDispatchToProps = {
    removeAd: discoverRoutines.removeAdFromDiscover,
    removeDiscover: discoverRoutines.removeDiscover,
    updateDiscover: discoverRoutines.updateDiscover,
    removeDocument: discoverRoutines.removeDocumentFromDiscover,
};
export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(DiscoverDetailsForm);
